import { Customer } from "@towersystems/roam-common/lib/generated-types";
import { useMemo } from "react";
import {
  Badge,
  Chip,
  FlatActionList,
  Stack,
  Text,
} from "@towersystems/roam-common-native";
import CustomerModel from "../../../../../../utilities/data/model/Customer";
import { View } from "react-native-ui-lib";

export interface CustomerListItemRendererProps {
  customer: Customer | CustomerModel;
  onAction?: () => void;
  retailerCustAccountOnly?: boolean;
}

export function CustomerListItemRenderer({
  customer,
  onAction,
  retailerCustAccountOnly,
}: CustomerListItemRendererProps) {
  const fullName = `${customer.firstName} ${customer.lastName}`;

  const badgeMarkup = customer.isRetailerCusAccount ? (
    <Badge retailerCustomerAccountStatus="RETAILER_CUSTOMER_ACCOUNT" />
  ) : null;

  const markup = useMemo(() => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: customer.id,
          title: fullName,
          disabled: retailerCustAccountOnly
            ? !customer.isRetailerCusAccount
            : false,
          titleContent({ title, subTitle }) {
            return (
              <View>
                <Stack centerVertical spacing={2}>
                  {title}
                  {badgeMarkup}
                </Stack>
                {subTitle}
              </View>
            );
          },
          subTitle: customer.emailAddress,
          onPress: onAction,
        }}
      />
    );
  }, [customer]);

  return markup;
}
